module.exports = __webpack_public_path__ + "media/fonts/suisse-works/SuisseWorks-Regular-89b8d66c1df261b1d7e8b67a266d8dc4.otf";